import {
  Alert,
  AlertColor,
  Box,
  Snackbar,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Content,
  ContentBody,
  ContentInput,
  ContentInputPassword,
  ContentInputProfilePhoto,
  ContentInputProfilePhotoIcon,
  ContentTitle,
  Title,
} from "./styles";
import { UserPermissions } from "../../App";
import { Select, Option } from "@mui/joy";
import TranslateIcon from "@mui/icons-material/Translate";

interface Props {
  userPermissions: UserPermissions;
}
const Users: React.FC<Props> = ({ userPermissions }) => {

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

  const [accountInfo, setAccountInfo] = useState({
    logo: "",
    username: "",
    firstName: "",
    lastName: "",
    birthDate: 0,
    language: "en-US",
    email: "",
    password: "",
    confirmPassword: ""
  });
  const editMyAccountInfo = () => {
    if(accountInfo.password !== "" && accountInfo.password !== accountInfo.confirmPassword){
      console.log("Not updated: Password and its confirmation are not equal");
      setStatusMsg(
        `Personal Account info was not updated (New password and its confirmation are not the same). Please try again.`
      );
      setStatusSeverity("error");
      setShowStatus(true);
      return;
    }

    fetch("/api/v1/account/myAccount/edit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountInfo),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          setStatusMsg("Personal Account info was updated!");
          setStatusSeverity("success");
          setShowStatus(true);
        } else {
          console.log("Not updated: ", data.reason);
          setStatusMsg(
            `Personal Account info was not updated (${data.reason + ""
            }). Refresh the page and try again.`
          );
          setStatusSeverity("error");
          setShowStatus(true);
        }
      });
  };
  const getMyAccountInfo = () => {
    fetch("/api/v1/account/myAccount", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) setAccountInfo(data);
      });
  };
  useEffect(() => {
    getMyAccountInfo();
  }, []);

  const onImageChangeClick = () => {
    if (hiddenLogoInput.current) {
      hiddenLogoInput.current.click();
    }
  };
  const onHiddenLogoInputChange = (event: any) => {
    const fileUploaded = event.target.files[0];

    var reader = new FileReader();
    var baseString;
    reader.onloadend = function () {
      baseString = reader.result;
      changeVar("logo", baseString + "");
    };
    reader.readAsDataURL(fileUploaded);
  };

  const changeVar = (varName: string, value: any) => {
    setAccountInfo({
      ...accountInfo,
      [varName]: value,
    });
    console.log(accountInfo);
  };

  return (
    <Container>
      <Title>
        My Account{" "}
        <Button
          onClick={() => {
            editMyAccountInfo();
          }}
        >
          Save Changes
        </Button>
      </Title>

      <Content>
        <ContentTitle>{accountInfo.username}</ContentTitle>

        <ContentBody>
          <ContentInput
            label="First Name"
            variant="standard"
            value={accountInfo.firstName}
            onChange={(ev) => changeVar("firstName", ev.target.value)}
          />
          <br />

          <ContentInput
            label="Last Name"
            variant="standard"
            value={accountInfo.lastName}
            onChange={(ev) => changeVar("lastName", ev.target.value)}
          />
          <br />

          <ContentInput
            label="Email"
            disabled
            variant="standard"
            style={{ marginBottom: "2rem" }}
            value={accountInfo.email}
            onChange={(ev) => changeVar("email", ev.target.value)}
          />
          <br />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Custom input"
              value={new Date(accountInfo.birthDate)}
              onChange={(newValue) => {
                if (newValue !== undefined && newValue !== null)
                  changeVar("birthDate", +newValue);
              }}
              renderInput={({ inputRef, inputProps, InputProps }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <input
                    ref={inputRef}
                    {...inputProps}
                    style={{
                      paddingBottom: "10px",
                      border: "none",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.5)",
                    }}
                  />
                  {InputProps?.endAdornment}
                </Box>
              )}
            />
          </LocalizationProvider>
          <br />

          <ContentInputPassword
            label="Password"
            onChange={(ev: any) => changeVar("password", ev.target.value)}
            style={{ marginTop: "0.5rem !important" }}
          />
          <br />

          <ContentInputPassword onChange={(ev: any) => changeVar("confirmPassword", ev.target.value)} label="Confirm Password" />
          <br />

          <ContentInputProfilePhoto onClick={onImageChangeClick}>
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img
              src={accountInfo.logo}
              alt="Click here to upload a profile photo"
            />
            <ContentInputProfilePhotoIcon />
            <input
              type="file"
              ref={hiddenLogoInput}
              onChange={onHiddenLogoInputChange}
              style={{ display: "none" }}
            />
          </ContentInputProfilePhoto>

          <Select
            placeholder="Language"
            startDecorator={<TranslateIcon />}
            sx={{ width: 240, marginTop: "30px" }}
            value={accountInfo.language}
            onChange={(e, newValue) => changeVar("language", newValue)}
          >
            <Option value="pt-PT">Português (Portugal)</Option>
            <Option value="en-US">English (United States)</Option>
          </Select>
          <br />
        </ContentBody>
      </Content>
      {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}

      <Snackbar
        open={showStatus}
        autoHideDuration={6000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Users;
